<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row">

                    <div class="col-md-12">

                        <h2 class="mb-3">
                            {{$t('text.auditLogExternalImport.title')}}
                        </h2>

                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card mb-3 form-condensed">
                            <div class="card-body bg-light">
                                <div class="row">
                                    <div class="col-md-12">
                                        <b-dropdown :text="$t('text.auditLogExternalImport.downloadSample.label')" variant="primary" size="sm" class="mb-4">
                                            <template v-slot:button-content>
                                                <i class="fa fa-download"></i> {{$t('text.auditLogExternalImport.downloadSample.label')}}
                                            </template>
                                            <b-dropdown-item @click="exportFile('json')" id="exportJson">{{$t('text.auditLogExternalImport.downloadSample.downloadJson')}}</b-dropdown-item>
                                            <b-dropdown-item @click="exportFile('xml')" id="exportXml">{{$t('text.auditLogExternalImport.downloadSample.downloadXML')}}</b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="file"> {{$t('text.auditLogExternalImport.fileToImport')}}</label>


                                                <input type="file" class="form-control" id="file"
                                                       aria-describedby="description"
                                                       accept=".json,application/json,.xml,application/xml"
                                                       @change="getFile"
                                                       ref="myFile"
                                                       name="file"
                                                />

                                        </div>
                                    </div>

                                </div>

                                <div class="row mt-2">
                                    <div class="col-md-12 text-right">
                                        <a class="btn btn-primary text-white" @click="importExternalAuditLog()"><i class="fas fa-file-import"></i> {{$t('text.auditLogExternalImport.importButton')}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <router-link :to="{name: 'AuditLogExternal'}" id="goToExternalAuditLog" type="submit" class="btn btn-secondary float-left">
                            {{$t('text.auditLogExternalImport.linkToExternalAuditLogSearch')}}
                        </router-link>
                    </div>
                </div>

            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import $ from 'jquery';
    import AudiLogExternalTable from "../components/AudiLogExternalTable";
    import jsonxml from 'jsontoxml';
    import convert from 'xml-js';

    export default {
        name: 'AuditLogExternalImport',
        components: {
            Loading,
            vSelect,
            AudiLogExternalTable,
        },

        data() {
            return {
                file: null,
                fileType: null,
                isLoading: false,
                sampleEntries: {
                    "extSystemId": "756",
                    "data": [
                        {
                            "timestamp": "2019-12-15T18:25:43.511Z",
                            "user": "administrator",
                            "values": {
                                "role": [
                                    "in-place readers",
                                    "records management administrator"
                                ],
                                "event": "Login successful"
                            }
                        },
                        {
                            "timestamp": "2019-10-01T18:25:43.511Z",
                            "user": "user",
                            "values": {
                                "event": "Login successful"
                            }
                        },
                        {
                            "timestamp": "2019-11-02T18:25:43.511Z",
                            "user": "administrator",
                            "values": {
                                "event": "Delete Object",
                                "role": [
                                    "In-Place Readers",
                                    "Records Management Administrator",
                                    "In-Place Writers"
                                ],
                                "ID": "2019-0000090226",
                                "type": "Record Category",
                                "location": "/AT - testni razred"
                            }
                        }
                    ]
                }
            };
        },

        computed: {},

        mounted() {
            const _this = this;

        },

        methods: {
            getFile() {
                const _this = this;

                let file = _this.$refs.myFile.files[0];
                _this.fileType = file.type.split('/')[1];

                if(file) {
                    let content  = "";
                    let reader = new FileReader();
                    reader.readAsText(file, "UTF-8");
                    reader.onload =  evt => {
                        _this.file = evt.target.result;

                        console.log("evt.target.result ", evt.target.result);
                    }
                    reader.onerror = evt => {
                        console.error(evt);
                    }
                }

            },
            importExternalAuditLog() {
                const _this = this;

                console.log("_this.file ---> ", _this.file);

                _this.isLoading = true;

                let file = _this.file;

                if(_this.fileType === 'xml') {

                    let options = {
                        compact: true,
                    };

                    let jsonStr = convert.xml2js(_this.file, options).logData;

                    console.log("jsonStr", jsonStr);

                    _.map(jsonStr.items, function (_val, index) {
                        _.map(_val, function (val, index) {
                            _.forOwn(val, function(value, key) {
                                if(key === 'values') {
                                    _.forOwn(jsonStr.items.item[index].values, function(_value, _key) {
                                        jsonStr.items.item[index].values[_key] = _value._text
                                    });
                                } else {
                                    jsonStr.items.item[index][key] = value._text
                                }
                            });
                        });
                    });

                    console.log("jsonStr", jsonStr);

                    let tmpStructure = {};
                    tmpStructure.extSystemId = jsonStr.extSystemId._text; 
                    tmpStructure.data = jsonStr.items.item;  

                    file = JSON.stringify(tmpStructure).replace(/_/g, "/");
                }

                console.log('file ----->', file);


                axios.post(config.externalAudit + 'import', file, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                    .then((res) => {
                        console.log("res",res);

                        Vue.$toast.open({
                            message: this.$t('text.auditLogExternalImport.auditLogExternalImportSuccessToast'),
                            type: 'success',
                            position: 'top-right'
                        });
                    })
                    .catch((error) => {
                        console.log("error", error);
                    });



            },
            exportFile(format) {

                let a;
                let e;
                let blob;

                if(format === 'json') {
                    const data = JSON.stringify(this.sampleEntries);
                    blob = new Blob([data], {type: 'text/plain'});
                    e = document.createEvent('MouseEvents');
                    a = document.createElement('a');
                    a.download = "vzorec_zunanje_revizijske_sledi.json";
                    a.href = window.URL.createObjectURL(blob);
                    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                } else {

                    let xml = {
                        "extSystemId": this.sampleEntries.extSystemId, 
                        items: []
                    };

                    _.map(this.sampleEntries.data, function (val) {
                        console.log("val", val);
                        xml.items.push(
                            {item: val}
                        )
                    });

                    console.log(xml);

                    const data = '<logData>' + jsonxml(xml, {escape:true, removeIllegalNameCharacters:true}) + '</logData>';
                    console.log("data", data);

                    blob = new Blob([data], {type: 'text/plain'});
                    e = document.createEvent('MouseEvents');
                    a = document.createElement('a');
                    a.download = "vzorec_zunanje_revizijske_sledi.xml";
                    a.href = window.URL.createObjectURL(blob);
                    a.dataset.downloadurl = ['application/xml', a.download, a.href].join(':');
                }

                e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/AuditLogExternalImport.vue